import { Col } from "react-bootstrap";
import MiniBarChart from "./MiniBarChart";

export default function ChartItem({ izinKey, data, color }) {
  return (
    <Col md={6}>
      <MiniBarChart
        title={`Top 5 ${izinKey}`}
        data={(data || []).map((d) => ({
          label: (d.URAIAN_PROPINSI || d.propinsi)?.toUpperCase(),
          value: d.Jumlah || d.jumlah || 0,
        }))}
        color={color}
      />
    </Col>
  );
}
